import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBatteryLoading: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="battery-loading, power"><path d="M7.75 5.75H1.75V18.25H5.25M15.75 5.75H19.25V18.25H13.25M12 6L7.5 12H13.5L9 18M19.25 8.75H22.25V15.25H19.25V8.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconBatteryLoading;
